import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const statusOptions = ["PENDING", "IN PROGRESS", "COMPLETE", "DELIVERED"]; // Status options for a sale

function StatusDropdown({ generalProps, handleGeneralPropsChange }) {
  const labelId = "status-select-label"; // Unique ID for InputLabel and Select

  return (
      <FormControl fullWidth>
        <InputLabel id={labelId}>Status</InputLabel>
        <Select
          labelId={labelId} // Link the Select to the InputLabel
          name="status"
          value={generalProps.status || ""} // Allow blank value if no status is set
          onChange={handleGeneralPropsChange}
        >
          <MenuItem value="">
            <em>None</em> {/* Option to leave the status blank */}
          </MenuItem>
          {statusOptions.map((status) => (
            <MenuItem key={status} value={status}>
              {status.charAt(0).toUpperCase() + status.slice(1)} {/* Capitalize first letter */}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
   
  );
}

export default StatusDropdown;
